"use client";

import React from "react";
import ModalUserSelectionExample from "@/examples/modals/ModalUserSelectionExample";

export default function ModalUserSelectionPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalUserSelectionExample />
    </div>
  );
}
